//https://angular.io/guide/dynamic-component-loader
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[lmsMediaItemHost]',
    standalone: true
})
export class LmsMediaItemDirective {
   constructor(public viewContainerRef: ViewContainerRef) {
      console.log('constructor:media item directive');
   }
}
